import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidenav from "../Sidenav/Sidenav"; // Sidenav component
import "./Home.css";

interface HomeProps {
    navigationItems: { to: string, icon: string, text: string }[];
}

const Home: React.FC<HomeProps> = ({ navigationItems }) => {
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleToggleSideNav = (isCollapsed: boolean, width: number) => {
        setCollapsed(isCollapsed);
        setScreenWidth(width);
    };

    const getBodyClass = () => {
        if (screenWidth <= 600) {
            return 'body-md-screen';  // Apply body-md-screen on small screens
        }
        return collapsed ? 'body-trimmed' : '';  // Apply body-trimmed if collapsed
    };

    return (
        <div className="content-layout">
            <Sidenav navigationItems={navigationItems} onToggleSideNav={handleToggleSideNav} />
            <div className={`hub-body ${getBodyClass()}`}>
                <Outlet />
            </div>
        </div>
    );
};

export default Home;
